<template>
  <div id="app">
    <component :is="layout">
      <router-view />
    </component>
    <GZ-ModalNotification />
  </div>
</template>

<script>
import Guest from '@/layouts/Guest'
import Admin from '@/layouts/Admin'
import Staff from '@/layouts/Staff'

export default {
  name: 'app',
  
  computed: {
      layout() {
      return this.$route.meta.layout
      //   try {
      //     if (this.$store.getters['authToken'] && this.$store.getters['authRole'].indexOf('ADMIN') > -1) {
      //       return Admin
      //     }
      //     if (this.$store.getters['authToken'] && this.$store.getters['authRole'].indexOf('PECHNIK') > -1) {
      //       return Staff
      //     }

      //     if (!this.$store.getters['authToken']) {
      //       return Guest
      //     }
      //   } catch (e) {
      //     console.log('Error: ', e)
      //   }
      // }
    }
  }
}
</script>

<style lang="sass">
  @import './assets/sass/styles'
</style>